export default __webpack_public_path__ + "static/media/Ellipse red (Stroke).66e6e8ab.svg";